import styled from 'styled-components'

type Props = {
	hasModal: boolean
}

export const AbsoluteContainer = styled.div<Props>`
	position: absolute;
	inset: 0;
	pointer-events: ${({ hasModal }) => (hasModal ? 'auto' : 'none')};
	z-index: 1000;
`
